import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store/store';
import { AuthProvider } from './contexts/AuthContext';
import App from './App';
import './config/firebase'; // Importer la configuration Firebase
import 'antd/dist/reset.css';  // Import Ant Design CSS
import './i18n'; // Import i18n configuration

// Vendor CSS
import './assets/icons/fontawesome/css/all.min.css';
import './assets/icons/feather/css/iconfont.css';
import './assets/icons/themify-icons/css/themify-icons.css';
import './assets/vendor/swiper/swiper-bundle.min.css';

// Application styles
import './styles/styles.scss';

const root = ReactDOM.createRoot(
  document.getElementById('root')
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <AuthProvider>
              <App />
          </AuthProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// Register the service worker in production so browsers can install Trakna as a PWA.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/service-worker.js`).catch((error) => {
      console.error('Service worker registration failed:', error);
    });
  });
}
